var breakpoints = {
  sm: [0, 768],
  md: [768, 1024],
  lg: [1024, 1200],
  xl: [1200]
};
export default breakpoints;